import type { ApiClientOptions } from '@/infra/api-client'
import { patchGrpcClient } from '@/utils/grpc-util'
import { BookkeepingServicePromiseClient } from '@taxfyle/api-internal/internal/bookkeeping_grpc_web_pb'
import { BundleServicePromiseClient } from '@taxfyle/api-internal/internal/bundle_grpc_web_pb'
import { JobScopeChangeServicePromiseClient } from '@taxfyle/api-internal/internal/job_scope_change_grpc_web_pb'
import type { RealtimeEvent } from '@taxfyle/api-internal/internal/realtime_pb'
import type { Observable } from 'rxjs'

export class AdminApi {
  readonly bundles
  readonly scopeChangeRequests
  readonly bookkeeping

  constructor(
    options: ApiClientOptions,
    readonly realtime$: Observable<RealtimeEvent>,
  ) {
    const baseURL = options.baseURL ?? ''

    this.bundles = new BundleServicePromiseClient(baseURL)
    patchGrpcClient(this.bundles, options.token$)

    this.scopeChangeRequests = new JobScopeChangeServicePromiseClient(baseURL)
    patchGrpcClient(this.scopeChangeRequests, options.token$)

    this.bookkeeping = new BookkeepingServicePromiseClient(baseURL)
    patchGrpcClient(this.bookkeeping, options.token$)
  }
}
